import { Component, HostListener, Inject, OnInit, Renderer2 } from "@angular/core";
import { Router, NavigationStart, NavigationError, NavigationEnd } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { TokenService } from "./core/token/token.service";
import { Subscription } from "rxjs";
import { SimpleCrypt } from "ngx-simple-crypt";
import { ThemeService } from "./shared/themes/theme.service";
import { DOCUMENT } from "@angular/common";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "./services/authentication.service";
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

export let browserRefresh = false;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  rotaIniciada: any;
  isAuth = false;
  isMobileResolution: boolean;
  subscription!: Subscription;
  show2FAInput: boolean = false;
  verificaChatCarregado: any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private tokenService: TokenService,
    private themeService: ThemeService,
    private authService: AuthenticationService,
    private _renderer2: Renderer2,
    private swUpdate: SwUpdate,
    @Inject(DOCUMENT) private _document: Document
  ) {

    this.translate.addLangs(['pt', 'es', 'en']);
    this.translate.setDefaultLang('pt');
    if (this.tokenService.getUsuario()) {
      this.translate.use(this.translate.getLangs()[(this.tokenService.getUsuario() as any).idioma - 1]);
    }

    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    this.themeService.currentMessageInadimplencia.subscribe(msg => {
      if (msg) {
        if (msg === 'remove') {
          this.recuoPaginasAlerta(true);
        } else {
          this.recuoPaginasAlerta();
        }
      }
    }, (error) => console.log('setTheme', error));

    //verificação de novo build para sw
    // Só executa se SW estiver habilitado
    if (this.swUpdate.isEnabled) {

      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (event): event is VersionReadyEvent =>
              event.type === 'VERSION_READY'
          )
        )
        .subscribe(() => {
          // força reload quando detectar versão nova
          window.location.reload();
        });

      this.swUpdate.unrecoverable.subscribe(event => {
        console.error('Versão irrecuperável do frontend', event.reason);

        window.__showAppRecovery?.(
          'SERVICE_WORKER_UNRECOVERABLE',
          event.reason
        );
      });
    }
  }

  @HostListener("window:resize", ["$event"])
  isMobile(event: any) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  ngOnInit(): void {
    this.setTheme();

    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.verificaAuth(event);

        if (localStorage.getItem('modo_tv')) {
          let decode: any = SimpleCrypt.decodeDefault("szHYxd7tz", (localStorage.getItem("modo_tv") as string))
          browserRefresh = !this.router.navigated && decode;
        }
      }

      if (event instanceof NavigationEnd) {
        sessionStorage.removeItem('chunk-recovery-attempted');
      }

      if (
        event instanceof NavigationError &&
        this.isChunkLoadError(event.error)
      ) {
        this.recoverFromChunkError(event.error);
      }
    }, (error) => console.log('verificaAuth', error));

    this.carregaScriptChat();
    this.addNPSScript();
  }


  getIndexIframeChat(collection: Iterable<unknown> | ArrayLike<unknown> | any, _body: any) {
    Array.from(collection).forEach((element: any, index) => {
      if (element === document.querySelector('#iframe_chat')) {
        /* _body.removeChild(collection[index+1]);       
        _body.removeChild(element);  */
        if (collection[index + 1]) collection[index + 1].remove();
        if (element) element.remove();
      }
    })
  }

  carregaScriptChat(): void {
    //chat novo
    //comentado separação de chats para implementação total do novo chat no sistema, caso estabilizado remover
    // if (environment.ambiente !== 'prod') {
    if (!this.tokenService.hasToken()) {
      let _scriptWidget = this._renderer2.createElement('script');
      _scriptWidget.type = 'application/javascript';
      _scriptWidget.id = 'script_widget';
      _scriptWidget.src = `${environment.scriptChatExterno}`;
      this._renderer2.appendChild(this._document.body, _scriptWidget);

      document.addEventListener('login-automatic-success', () => {
        let _script_widget = document.getElementById('script_widget');
        let _iframes = document.getElementsByTagName('iframe');
        let _body = document.getElementById('body-milvus');

        _script_widget?.remove();
        if (_iframes[0]) _iframes[0].remove();
        if (_iframes[0]) _iframes[0].remove();
        setTimeout(() => {
          this.carregaScriptChat();
        }, 1000);
      });
    } else {
      const usuarioLogado = this.tokenService.getUsuario();

      if (usuarioLogado?.is_login_automatico) {
        return;
      }

      let _scriptWidget2 = this._renderer2.createElement('script');
      _scriptWidget2.type = 'application/javascript';
      _scriptWidget2.id = 'script_widget';
      _scriptWidget2.src = `${environment.scriptChatExterno}`;
      this._renderer2.appendChild(this._document.body, _scriptWidget2);

      this.verificaChatCarregado = setInterval(() => {
        const contactInfo = {
          email: usuarioLogado?.username,
          nome: usuarioLogado?.nome,
          country: "+55",
          telefone: "",
          inicia_aberto: true
        };

        if (document.getElementById('iframe_chat')) {
          document.getElementById('iframe_chat')?.classList.add('opacity-0');
          window.postMessage(
            { type: "CONTACT_INFO", payload: contactInfo }, '*'
          );
          clearInterval(this.verificaChatCarregado);
        }
      }, 100);
    }

    document.addEventListener('openButton', () => {
      if (document.getElementById('iframe_chat')) {
        document.getElementById('iframe_chat')?.classList.remove('opacity-0');
      }
    });

    document.addEventListener('closeButton', () => {
      if (document.getElementById('iframe_chat')) {
        document.getElementById('iframe_chat')?.classList.add('opacity-0');
      }
    });
    // } else {//chat antigo
    //   if (!this.tokenService.hasToken()) {
    //     let _scriptWidget = this._renderer2.createElement('script');
    //     _scriptWidget.type = 'application/javascript';
    //     _scriptWidget.id = 'script_widget';
    //     _scriptWidget.src = `${environment.scriptChatExterno}`;
    //     this._renderer2.appendChild(this._document.body, _scriptWidget);

    //     if (window['chatMilvus']) {
    //       let _initWidget = this._renderer2.createElement('script');
    //       _initWidget.type = 'application/javascript';
    //       _initWidget.id = 'init_widget';
    //       _initWidget.text = `window.onload = function () {
    //       chatMilvus.init({
    //         email: "",
    //         nome: "",
    //         country: "+55",
    //         telefone: ""
    //       });
    //     };`;
    //       this._renderer2.appendChild(this._document.body, _initWidget);
    //     }

    //     document.addEventListener('login-automatic-success', () => {
    //       let _script_widget = document.getElementById('script_widget');
    //       let _script_init = document.getElementById('init_widget');
    //       let _iframes = document.getElementsByTagName('iframe');
    //       let _body = document.getElementById('body-milvus');

    //       _script_widget?.remove();
    //       _script_init?.remove();
    //       if (_iframes[0]) _iframes[0].remove();
    //       if (_iframes[0]) _iframes[0].remove();
    //       setTimeout(() => {
    //         this.carregaScriptChat();
    //       }, 1000);
    //     });
    //   } else {
    //     const usuarioLogado = this.tokenService.getUsuario();

    //     let _scriptWidget2 = this._renderer2.createElement('script');
    //     _scriptWidget2.type = 'application/javascript';
    //     _scriptWidget2.id = 'script_widget';
    //     _scriptWidget2.src = `${environment.scriptChatExterno}`;
    //     this._renderer2.appendChild(this._document.body, _scriptWidget2);

    //     this.verificaChatCarregado = setInterval(() => {
    //       if (window['chatMilvus']) {
    //         clearInterval(this.verificaChatCarregado);
    //         let _initWidget2 = this._renderer2.createElement('script');
    //         _initWidget2.type = 'application/javascript';
    //         _initWidget2.id = 'init_widget';
    //         _initWidget2.text = `
    //         window.chatMilvus.init({
    //           email: '${usuarioLogado?.username}',
    //           nome: '${usuarioLogado?.nome}',
    //           country: "+55",
    //           telefone: "",
    //           inicia_aberto: true
    //         });`;
    //         this._renderer2.appendChild(this._document.body, _initWidget2);
    //       }

    //       if (document.getElementById('iframe_chat')) {
    //         document.getElementById('iframe_chat').classList.add('opacity-0');
    //       }
    //     }, 100);
    //   }

    //   document.addEventListener('openButton', () => {
    //     if (document.getElementById('iframe_chat')) {
    //       document.getElementById('iframe_chat').classList.remove('opacity-0');
    //     }
    //   });

    //   document.addEventListener('closeButton', () => {
    //     if (document.getElementById('iframe_chat')) {
    //       document.getElementById('iframe_chat').classList.add('opacity-0');
    //     }
    //   });
    // }
  }

  setTheme(): void {
    if (window.localStorage.getItem('theme') !== null) {
      if (window.localStorage.getItem('theme') === 'dark') {
        this.themeService.setDarkTheme();
        this.loadTheme('material-dark')
      } else {
        this.themeService.setLightTheme();
        this.loadTheme('material')
      }
    } else {
      this.themeService.setLightTheme();
    }
  }

  verificaAuth(event: NavigationStart): void {
    if (event?.url === '/login' || event?.url === '/trial/free-trial-ended' || event?.url === '/remote-access' || event?.url.includes('/outside-auth/confirm-auth')) {
      this.blockAllow(false);
    } else {
      setTimeout(() => {
        this.blockAllow(true);
        this.rotaIniciada = event?.url.split(';')[0];
      }, 300);
    }
  }

  blockAllow(bool: boolean): void {
    if (bool) {
      document.querySelector('#d932kdds9fd9v')?.classList.add('main-content');
      this.isAuth = true;
    } else {
      setTimeout(() => {
        document.querySelector('#d932kdds9fd9v')?.classList.remove('main-content');
        this.isAuth = false;
      }, 300);
    }
  }

  loadTheme(theme: 'material' | 'material-dark') {
    const existingLink = document.getElementById('theme-css') as HTMLLinkElement;

    if (existingLink) {
      existingLink.href = `assets/styles/${theme}.css`;
    } else {
      const link = document.createElement('link');
      link.id = 'theme-css';
      link.rel = 'stylesheet';
      link.href = `assets/styles/${theme}.css`;
      document.head.appendChild(link);
    }
  }

  recuoPaginasAlerta(remove?: boolean | undefined): void {
    if (remove) {
      document.querySelector('#d932kdds9fd9v')?.classList.remove('main-content-with-alerts');
    } else {
      document.querySelector('#d932kdds9fd9v')?.classList.add('main-content-with-alerts');
    }
  }

  addNPSScript(): void {
    try {
      console.log('Adicionando script NPS...');

      const usuarioLogado = this.tokenService.getUsuario();
      if (!usuarioLogado) return;

      // if (environment.ambiente != 'prod' && environment.ambiente !== 'production-release') return; // Desabilita o NPS em ambiente de desenvolvimento

      const habilitarNps = usuarioLogado?.visualiza_pesquisa_nps;
      if (!habilitarNps) return;

      console.log('Usuário habilitado para NPS. Carregando script...');

      const _scriptNps = this._renderer2.createElement('script');
      _scriptNps.id = 'script_nps';

      // Define o conteúdo JavaScript da tag
      _scriptNps.text = `
        (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:5335534,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;

      this._renderer2.appendChild(this._document.body, _scriptNps);

      let _initNps = this._renderer2.createElement('script');
      _initNps.type = 'application/javascript';
      _initNps.id = 'init_nps';
      _initNps.text = `
        window.hj = window.hj || function(){(hj.q = hj.q || []).push(arguments)};
        var userId = ${usuarioLogado.id};
        var userEmail = '${usuarioLogado.username}';
        hj('identify', userId, {
        user_id: userId,
        email: userEmail,
        first_name: '${usuarioLogado.nome}',
        company: '#${usuarioLogado.empresa_id}',
        // Adicione campos adicionais se necessário
        });
    `;

      this._renderer2.appendChild(this._document.body, _initNps);
    } catch (error) {
      console.error('Erro ao carregar script NPS', error);
    }
  }

  private recoverFromChunkError(error: unknown): void {
    const recoveryKey = 'chunk-recovery-attempted';

    if (!sessionStorage.getItem(recoveryKey)) {
      sessionStorage.setItem(recoveryKey, 'true');
      window.location.reload();
      return;
    }

    window.__showAppRecovery?.(
      'LAZY_CHUNK_ERROR',
      this.getErrorMessage(error)
    );
  }

  private isChunkLoadError(error: unknown): boolean {
    const message = this.getErrorMessage(error);

    return (
      message.includes('ChunkLoadError') ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module')
    );
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }

    return String(error || '');
  }
}
